import { all, put, select, takeEvery } from 'redux-saga/effects';
import { DEPARTURE_TYPE_OPTIONS } from 'constants/options';
import {
  packageDepartureTypeSelector,
  packageDepartureRemovePacketIDSelector,
} from './selectors';
import { actions } from './slice';
import { actions as paqueryPointDepartureActions } from '../packagePaquerypointDeparture/slice';

function* removePacketSaga() {
  const departureType = yield select(packageDepartureTypeSelector);
  const packetID = yield select(packageDepartureRemovePacketIDSelector);
  switch (departureType) {
    case DEPARTURE_TYPE_OPTIONS.PAQUERYPOINT:
      yield put({
        type: paqueryPointDepartureActions.removePacketSuccess.type,
        payload: packetID,
      });
      break;
    default:
      break;
  }
  yield put({
    type: actions.resetRemovePacketID.type,
  });
}

export default function* rootSaga() {
  yield all([takeEvery(actions.removePacket, removePacketSaga)]);
}
